import React, { useEffect } from 'react';

import { ErrorCard } from '@eika/card';
import { CheckmarkAnimation } from '@eika/checkmark-animation';

import { useAccountNumberFromQueryParam } from '@/react-query/hooks/query/use-account';
import { useGetDebitCardSigningOrder } from '@/react-query/hooks/query/use-get-debit-card-signing-order';

import SigningOrderErrorView from '@components/order-card-form/order-card-form-signing-result-container/SigningOrderErrorView';
import { DebitCardOrderStatus } from '@generated-types';
import useText from '@hooks/use-text';

const OrderCardFormSigningResultContainer = () => {
    const { signingOrderUnknownStatusError } = useText();
    const accountNumber = useAccountNumberFromQueryParam();
    const cardOrderQuery = useGetDebitCardSigningOrder(accountNumber);
    const signingStatus = cardOrderQuery.data?.order?.status;

    const sendCloseModal = () => {
        window.parent.postMessage('close-modal', '*');
    };

    useEffect(() => {
        if (cardOrderQuery.isFetched) {
            if (signingStatus === DebitCardOrderStatus.SIGNED) {
                sendCloseModal();
            }
        }
    }, [cardOrderQuery.isFetched, signingStatus]);

    if (!cardOrderQuery.isFetched) {
        return null;
    }

    if (signingStatus === DebitCardOrderStatus.SIGNED) {
        return (
            <div className="signing-result-container">
                <div className="success-container">
                    <div>
                        <CheckmarkAnimation />
                    </div>
                </div>
            </div>
        );
    }

    if (signingStatus === DebitCardOrderStatus.FAILED || signingStatus === DebitCardOrderStatus.ACTIVE) {
        return <SigningOrderErrorView cardOrder={cardOrderQuery.data} />;
    }

    return <ErrorCard title="" description={signingOrderUnknownStatusError} />;
};

export default OrderCardFormSigningResultContainer;
